import { quickFacts } from '../../../mocks/relocation';

export default function RelocationHero() {
  return (
    <section className="relative bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600 text-white py-24">
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium mb-6">
            <i className="ri-map-pin-line text-lg"></i>
            <span>Your Complete Relocation Guide</span>
          </div>
          <h1 className="text-5xl font-bold mb-6">
            Welcome to Roseville, California
          </h1>
          <p className="text-xl text-white/90 mb-8">
            Everything you need to know about moving to Roseville. From neighborhoods and schools to utilities and local tips—we've got you covered.
          </p>
          <div className="flex flex-wrap gap-4">
            <a
              href="#overview"
              className="bg-white text-emerald-600 px-8 py-4 rounded-lg font-semibold hover:bg-emerald-50 transition-colors whitespace-nowrap"
            >
              Explore Guide
            </a>
            <a
              href="/relocation-partners"
              className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap border border-white/30 flex items-center gap-2"
            >
              <i className="ri-team-line"></i>
              <span>Find Local Partners</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
